import React from "react";

function Pagination({ total, page, limit, onPageChange, align = "center" }) {
  const justifyMap = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
  };
  const totalPages = Math.ceil(total / limit);

  if (totalPages <= 1) return null;

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    // Show only nearby pages for cleaner UI
    if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  return (
    <div style={{ display: "flex", justifyContent: justifyMap[align], marginTop: 20, gap: 8 }}>
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        style={{ padding: "6px 12px", cursor: page === 1 ? "not-allowed" : "pointer" }}
      >
        Previous
      </button>

      {pages.map((p, idx) =>
        p === "..." ? (
          <span key={idx} style={{ padding: "6px 12px" }}>
            ...
          </span>
        ) : (
          <button
            key={idx}
            onClick={() => onPageChange(p)}
            style={{
              padding: "6px 12px",
              fontWeight: page === p ? "bold" : "normal",
              backgroundColor: page === p ? "#007FFF" : "transparent",
              color: page === p ? "#fff" : "#007FFF",
              border: "1px solid #007FFF",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            {p}
          </button>
        ),
      )}

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        style={{ padding: "6px 12px", cursor: page === totalPages ? "not-allowed" : "pointer" }}
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;
